import { render } from "./Store.vue?vue&type=template&id=bf46aec2&scoped=true"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"

import "./Store.vue?vue&type=style&index=0&id=bf46aec2&lang=scss&scoped=true"

import exportComponent from "F:\\my_work_space\\cmall-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf46aec2"]])

export default __exports__